import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Apply theme to document
 */
function applyTheme(isDarkMode) {
  if (isDarkMode) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}

/**
 * Theme store for managing dark/light mode
 */
export const useThemeStore = create(
  persist(
    (set, get) => ({
      isDarkMode: false,

      /**
       * Toggle dark mode on/off
       */
      toggleDarkMode: () => {
        const newValue = !get().isDarkMode;
        set({ isDarkMode: newValue });
        applyTheme(newValue);
      },

      /**
       * Set dark mode explicitly
       */
      setDarkMode: (value) => {
        set({ isDarkMode: value });
        applyTheme(value);
      },

      /**
       * Initialize theme on app load
       */
      initTheme: () => {
        const { isDarkMode } = get();
        applyTheme(isDarkMode);
      },
    }),
    {
      name: 'halomts-theme',
      onRehydrateStorage: () => (state) => {
        // Apply theme after state is rehydrated from localStorage
        if (state) {
          applyTheme(state.isDarkMode);
        }
      },
    }
  )
)
